<template>
	<div :class="{'is-invalid': validation?.$error}">
		<div class="d-flex align-items-center mb-1" v-if="!!title || !!subtitle">
			<label class="form-label mb-0 fw-bold lh-sm" :for="inputId">{{ title }}</label>
			<div class="ms-auto lh-1" v-if="subtitle">
				<span class="text-sm text-muted" v-html="subtitle"></span>
			</div>
		</div>
		<slot />
		<CommonMessageInfo class="mt-2" :info="info" v-if="info" />
		<span class="mt-1 invalid-feedback fw-bold" v-for="error of validation?.$errors ?? []" :key="error.$uid">{{ error.$message }}</span>
	</div>
</template>

<script>
	export default {
		props: {
			inputId: String,
			title: String,
			subtitle: String,
			info: String,
			validation: Object
		}
	}
</script>